import type { Meta, StoryObj } from '@storybook/angular';
import { expect, within } from 'storybook/test';
import { BreadcrumbsComponent } from '../../app/content/layout/components/general/breadcrumbs/breadcrumbs.component';
import { withCommonDecorators } from '../_utils/story-helpers';
import { BreadcrumbService } from '../../app/core/services/breadcrumb.service';
import { of } from 'rxjs';

function breadcrumbProvider(crumbs: { label: string; path: string }[], style = 'dark') {
  return {
    provide: BreadcrumbService,
    useValue: {
      getCurrentBreadcrumbsAsync: () => of(crumbs),
      getCurrentStyleAsync: () => of(style),
    },
  };
}

const meta: Meta<BreadcrumbsComponent> = {
  title: 'Molecules/Breadcrumbs',
  component: BreadcrumbsComponent,
  parameters: {
    docs: {
      description: {
        component: 'Page breadcrumbs navigation showing the current page hierarchy.',
      },
    },
  },
};

export default meta;
type Story = StoryObj<BreadcrumbsComponent>;

export const Default: Story = {
  decorators: [...withCommonDecorators([
    breadcrumbProvider([
      { label: 'Forside', path: '/' },
      { label: 'Rødvin', path: '/rodvin' },
      { label: 'Château Margaux 2020', path: '/rodvin/chateau-margaux-2020' },
    ]),
  ])],
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText('Forside')).toBeInTheDocument();
    await expect(canvas.getByText('Rødvin')).toBeInTheDocument();
  },
};

export const SingleLevel: Story = {
  decorators: [...withCommonDecorators([
    breadcrumbProvider([
      { label: 'Forside', path: '/' },
    ]),
  ])],
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText('Forside')).toBeInTheDocument();
  },
};

export const DeepHierarchy: Story = {
  decorators: [...withCommonDecorators([
    breadcrumbProvider([
      { label: 'Forside', path: '/' },
      { label: 'Rødvin', path: '/rodvin' },
      { label: 'Frankrig', path: '/rodvin/frankrig' },
      { label: 'Bordeaux', path: '/rodvin/frankrig/bordeaux' },
      { label: 'Margaux', path: '/rodvin/frankrig/bordeaux/margaux' },
      { label: 'Château Margaux 2020', path: '/rodvin/frankrig/bordeaux/margaux/chateau-margaux-2020' },
    ]),
  ])],
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText('Bordeaux')).toBeInTheDocument();
  },
};

export const LightStyle: Story = {
  decorators: [...withCommonDecorators([
    breadcrumbProvider([
      { label: 'Forside', path: '/' },
      { label: 'Hvidvin', path: '/hvidvin' },
      { label: 'Chablis 2021', path: '/hvidvin/chablis-2021' },
    ], 'light'),
  ])],
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText('Hvidvin')).toBeInTheDocument();
  },
};

export const Empty: Story = {
  decorators: [...withCommonDecorators([
    breadcrumbProvider([]),
  ])],
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-breadcrumbs')).toBeTruthy();
  },
};
